import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { deleteTrailingSpaces } from '../../utils/delete-extra-characters';
import { ActionsService } from '../../api/actions.service';
import { ClientActionService } from '../../services/client-action.service';
import { environment } from '../../../environments/environment';
import Routes from '../../constants/routes.const';
import { ActivatedRoute, Router } from '@angular/router';
import { ValidationService } from '../../components/form-fields/validation.service';
import validateAllFormFields from '../../utils/validate-all-form-fields';
import { ClientInfoService } from '../../services/client-info.service';
import { take, timeout } from 'rxjs/operators';
import { StorageService } from '../../services/storage.service';
import AuthType from '../../constants/auth-type.constant';
import detectMobile from 'src/app/utils/detect-mobile';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { AnalyticsEventsService } from '../../services/analytic.service';
import {StorageConst} from "../../constants/storage.const";

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.sass'],
})
export class LoginComponent implements OnInit {
  public authorizationForm: UntypedFormGroup;
  public brand: string;
  public deleteSpaces = deleteTrailingSpaces;
  public showError = false;
  public deactivate = false;
  public isMobile = detectMobile();
  public routesConst = Routes;
  public showRestorePhone = false;
  public restorePhone: number;
  public disabled = false;

  constructor(
    private _fb: UntypedFormBuilder,
    private _actionService: ActionsService,
    private _clientActionService: ClientActionService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _clientInfo: ClientInfoService,
    private _storageService: StorageService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private analyticService: AnalyticsEventsService
  ) {
    this.brand = environment.brand;
  }

  ngOnInit() {
    const phone = this._storageService.get(StorageConst.PHONE_RECOVERY_VALUE);
    this._storageService.remove(StorageConst.PHONE_RECOVERY_VALUE);

    this.authorizationForm = this._fb.group({
      phone: [
        phone ? phone : '',
        Validators.compose([
          Validators.required,
          ValidationService.phonelength,
          ValidationService.nonexistentphone,
        ]),
      ],
      password: ['', Validators.compose([Validators.required])],
    });

    if (phone) {
      this.showRestorePhone = true;
      this.restorePhone = phone;
    }

    this.analyticService.eventYandexMetrica('load_page_login');
  }

  public sendWithCaptcha(event, { valid, value }): void {
    let tokenStr;
    this.recaptchaV3Service
      .execute('sendCodeLogin')
      .pipe(timeout(30000))
      .subscribe({
        next: (token: string) => {
          tokenStr = token;
        },
        error: (err: string) => {
          this.submitForm(event, { valid, value }, null);
        },
        complete: () => {
          this.submitForm(event, { valid, value }, tokenStr);
        },
      });
  }

  public submitForm(event, { valid, value }, token): void {
    event.preventDefault();

    validateAllFormFields(this.authorizationForm);

    this.analyticService.eventYandexMetrica('click_login');

    if (valid) {
      this.disabled = true;
      value.phone = this._clientActionService.changePhoneFormat(value.phone);
      this._actionService
        .authorization(
          AuthType.PASSWORD,
          value.phone,
          value.password,
          token,
          this.brand
        )
        .subscribe({
          next: (response) => {
            this._storageService.set(
              'ACCESS_TOKEN',
              response.data.access_token,
              'cookie'
            );
            this._storageService.set(
              'EXPIRES_IN',
              response.data.expires_in,
              'cookie'
            );
            this._storageService.set(
              'TOKEN_TYPE',
              response.data.token_type,
              'cookie'
            );
            this.analyticService.sendDataClient(value.phone);
            this._actionService
              .getClientInformation()
              .pipe(take(1))
              .subscribe((res) => {
                this._clientInfo.setClient(res);
                this._router.navigate([this.routesConst.CABINET_PAGE], {
                  queryParamsHandling: 'merge',
                });
              });
            this.analyticService.eventYandexMetrica('click_login_valid_data');
          },
          error: (error) => {
            this.disabled = false;
            this.deactivate = error.error.error.type === 'DisabledException';
            this.showError = true;
            this.analyticService.eventYandexMetrica('click_login_invalid_data');
          },
        });
    } else {
      this.analyticService.eventYandexMetrica('click_login_invalid_data');
    }
  }

  /**
   * The method redirects to recovery page
   */
  public redirectToRecovery(): void {
    if (this.authorizationForm.get('phone').valid) {
      this._storageService.set(
        StorageConst.PHONE_RECOVERY_VALUE,
        this.authorizationForm.get('phone').value
      );
    }
    this._router.navigate([this.routesConst.PASSWORD_RECOVERY_PAGE], {
      queryParamsHandling: 'merge',
    });
    this.analyticService.eventYandexMetrica('click_redirect_recovery_password');
  }

  /**
   * The method open first step of registration and clear storages
   */
  public registration(): void {
    this._storageService.clear('ss');
    this._storageService.clear('ls');
    this._storageService.clear('cookie');
    this._router.navigate([this.routesConst.FIRST_REG_STEP], {
      queryParamsHandling: 'merge',
    });
  }

  /**
   * The method hide error message
   */
  public clearError(): void {
    this.showError = false;
  }
}
